<script setup lang="ts">
import '@shoelace-style/shoelace/dist/components/skeleton/skeleton.js';

const { isShim = true } = defineProps<{ isShim?: boolean }>();
</script>

<template>
  <sl-skeleton
    :effect="isShim ? 'sheen' : ''"
    :class="isShim ? 'sheen' : ''"
  />
</template>

<style scoped lang="postcss">
sl-skeleton {
  --color: #121c2f;
  --sheen-color: #1a2740;
  --border-radius: var(--border-radius-default);

  width: 100%;

  &::part(indicator) {
    background-color: var(--color-bg-dark-blue);
  }

  &.shim {
    &::part(indicator) {
      background: linear-gradient(
        103deg,
        var(--color) 5.66%,
        var(--sheen-color) 37.12%,
        #213252 51.26%,
        var(--sheen-color) 64.67%,
        var(--color) 96.5%
      );
      background-size: 400% 100%;
      user-select: none;
    }
  }
}
</style>
